import { Pipe, PipeTransform } from '@angular/core';
import { ShippabilityStatus } from '@shared/service-proxies/service-proxies';

export function transformShippabilityStatusToString(status: number): string {
    if (status === undefined) {
        return '-';
    }

    switch (status) {
        case ShippabilityStatus.AvailableForOrder: return 'Available for Orders';
        case ShippabilityStatus.Hold: return 'Hold';
        case ShippabilityStatus.InProcess: return 'In Process';
        case ShippabilityStatus.InspectDamagedExpired: return 'Inspect / Damaged / Expired';
        case ShippabilityStatus.PickedStaged: return 'Picked / Staged';
        default: return 'Unknown';
    }
}

@Pipe({ name: 'shippabilityStatus' })
export class ShippabilityStatusPipe implements PipeTransform {

    transform(status: number): string {
        return transformShippabilityStatusToString(status);
    }
}
